(() => {
  if (customElements.get('hp26-shop-categories')) return;

  class HP26ShopCategories extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.swiper = null;
    }

    connectedCallback() {
      if (typeof window.Swiper === 'undefined' || !this.swiperEl) return;
      if (this.swiper) return;

      const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
      if (!slideCount) return;

      // Never reserve empty columns — cap slidesPerView to real tile count
      const perView = (n) => Math.min(n, slideCount);

      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: perView(2.5),
        spaceBetween: 8,
        watchOverflow: true,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          640: {
            slidesPerView: perView(3),
          },
          768: {
            slidesPerView: perView(4),
          },
          1024: {
            slidesPerView: perView(5),
          },
        },
      });
    }

    disconnectedCallback() {
      if (this.swiper && typeof this.swiper.destroy === 'function') {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('hp26-shop-categories', HP26ShopCategories);
})();
